import IPUtility from "../classes/IPUtility";

export interface IPAuditMember {
  // DB Fields
  uid: number; // 고유번호
  projectUID: number; // 프로젝트 고유번호
  displayOrder: number; // 표시 순서
  name: string; // 성명
  department: string; // 소속 및 지위
  position: string; // 감사상 직책 및 경력
  duty: string; // 주요 감사 내용

  // NotDB
  uuid: string; // UUID값
}

export const initializeAuditMember: IPAuditMember = {
  uid: 0,
  projectUID: 0,
  displayOrder: 0,
  name: "",
  department: "",
  position: "",
  duty: "",
  uuid: IPUtility.generateUUID(),
};
